var mobile='600px';var tablet='1024px';export{// eslint-disable-next-line import/prefer-default-export
mobile,tablet};